import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import ThemedText from '../../components/theme/ThemedText';
import { CHAINS } from '../../constants';
import { useBackendApi } from '../../helpers/backendHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import InviteWrapper from './InviteWrapper';
import './Review.scss';
import Feed from './Tabs/Feed';
import Invite from './Tabs/Invite';
import TwitterTakes from './Tabs/TwitterTakes';
import Write from './Tabs/Write';

const HEADINGS = {
  alreadyPosted: 'Already Posted',
  notEligible: 'Not Eligible',
  eligible: 'Eligible To Post',
};

const DISABLED_CATEGORIES = new Set(['notEligible']); //'alreadyPosted'

const Review = ({ tab = 0 }) => {
  const [{ protocolMapping }] = useGlobalState();
  const [activeTab, setActiveTab] = useState(tab);
  const [eligibleProtocols, setEligibleProtocols] = useState(new Set([]));
  const [reactionEligible, setReactionEligible] = useState(new Set([]));
  const [projectStatus, setProjectStatus] = useState({});
  const backendHelper = useBackendApi();
  const [reviewTag, setReviewTag] = useState();
  // const [reviewedTags, setReviewdTags] = useState();
  const history = useNavigate();

  const [refreshKey, setRefreshKey] = useState(0);

  const SIDEBAR = [
    {
      name: 'Your Feed',
      mobile_name: 'Feed',
      id: 0,
      component: <Feed key={`feed-${refreshKey}`} eligibleProtocols={eligibleProtocols} handleTab={handleTab} reactionEligible={reactionEligible} />,
    },
    {
      name: 'Twitter Takes',
      mobile_name: 'X Takes',
      id: 1,
      component: (
        <TwitterTakes
          key={`tweeterTakes-${refreshKey}`}
          eligibleProtocols={eligibleProtocols}
          handleTab={handleTab}
          reviewTag={reviewTag}
          reactionEligible={new Set([...eligibleProtocols, ...reactionEligible])}
        />
      ),
    },
    {
      name: 'Write a Take',
      mobile_name: 'Write',
      id: 2,
      component: <Write projectStatus={projectStatus} getProjectStatus={getReviewedProtocol} reviewTag={reviewTag} />,
    },
    // {
    //   name: 'Leaderboard',
    //   id: 2,
    //   component: <LeaderBoard handleTab={handleTab} />,
    // },
    // {
    //   name: 'Review Queue',
    //   id: 2,
    //   component: <Queue eligibleProtocols={eligibleProtocols} />,
    // },

    {
      name: 'Invite',
      mobile_name: 'Invite',
      id: 3,
      component: <Invite />,
    },
  ];

  async function getEligibileProtocols() {
    try {
      const data = await backendHelper.reviews.eligibileProtocols();
      setEligibleProtocols(new Set([...data?.data]));
    } catch (error) {
      console.log('Error is getting EligibileProtocols', error);
    }
  }

  async function getReactionEligible() {
    try {
      const data = await backendHelper.reviews.getReactionEligible();
      setReactionEligible(new Set([...data?.data]));
    } catch (error) {
      console.log('Error is getting getReactionEligible', error);
    }
  }

  function handleTab(value) {
    const tabId = Number(value);
    if (tabId === activeTab) {
      setRefreshKey(prev => prev + 1);
    } else {
      setActiveTab(tabId);
    }
  }

  function handleRedirect(value) {
    history('/takes');
    handleTab(value);
  }

  function handleProtocol(item, category) {
    if (String(item?.protocol).startsWith('chain')) {
      return {
        ...item,
        disabled: DISABLED_CATEGORIES.has(category),
        ...(CHAINS?.[String(item?.protocol).split('-')[1]] || {}),
      };
    }
    return {
      ...item,
      disabled: DISABLED_CATEGORIES.has(category),
      ...(protocolMapping?.[item?.protocol] || {}),
    };
  }
  async function getReviewedProtocol() {
    try {
      const data = await backendHelper.reviews.userProtocolStatsWithRating();
      const rawData = data.data;
      const transformedData = Object.entries(rawData).reduce((acc, [category, items]) => {
        acc[HEADINGS[category] ? HEADINGS[category] : category] = items.map(item => handleProtocol(item, category));
        return acc;
      }, {});
      setProjectStatus(transformedData);
    } catch (error) {
      console.log('error is getting reviwedProtocol', error);
    }
  }

  async function getAllReviewTag() {
    try {
      const response = await backendHelper.reviews.getAllReviewsTag();
      setReviewTag(response.data);
    } catch (error) {
      console.log('error is getting reviewTags', error);
    }
  }

  // async function getReviewedReviewTag() {
  //   try {
  //     const response = await backendHelper.reviews.getReviewTagsWithReviews();
  //     setReviewdTags(response.data);
  //   } catch (error) {
  //     console.log('error is getting reviewTags', error);
  //   }
  // }

  useEffect(() => {
    getEligibileProtocols();
    getReviewedProtocol();
    getAllReviewTag();
    getReactionEligible();
    // getReviewedReviewTag();
  }, []);

  return (
    <InviteWrapper eligibileProtocols={eligibleProtocols}>
      <Flexbox className='review_wrapper' alignItems='flex-start'>
        <Flexbox className='review_wrapper_bottombar'>
          {SIDEBAR.map(item => (
            <ThemedText.P key={item.id} className={Boolean(item.id === activeTab) ? 'review_wrapper__sidebar_active' : ''} onClick={() => handleRedirect(item?.id)}>
              {item?.mobile_name}
            </ThemedText.P>
          ))}
        </Flexbox>

        <div className='review_wrapper__content'>
          <FlexboxColumn className='review_wrapper__sidebar' justifyContent={'flex-start'} alignItems={'flex-start'}>
            <div className='review_wrapper__sidebar_filler'></div>
            {SIDEBAR.map(item => (
              <ThemedText.P key={item.id} className={Boolean(item.id === activeTab) ? 'review_wrapper__sidebar_active' : ''} onClick={() => handleRedirect(item?.id)}>
                {item?.name}
              </ThemedText.P>
            ))}
          </FlexboxColumn>
          {SIDEBAR[activeTab].component}
        </div>
      </Flexbox>
    </InviteWrapper>
  );
};

export default Review;
